import * as React from 'react';
import { useEffect } from 'react';
import { useI18n } from '../../../Translation';
import Spinner from '../Spinner';
import { useUpdateCourseProgress } from './Hooks/useUpdateCourseProgress';
import { useCheckLectureWatchtime } from './Hooks/useCheckLectureWatchtime';
import { toast } from 'react-hot-toast';
const CourseLectureProgressButton = (props) => {
    const mutation = useUpdateCourseProgress();
    const { data: watchtimeData, isLoading: isCheckingWatchtime } = useCheckLectureWatchtime({
        courseUuid: props.courseUuid,
        lectureUuid: props.lectureUuid,
    });
    const i18n = useI18n();
    const canProgress = watchtimeData?.hasAccess ?? false;
    const percentage = watchtimeData?.percentage ?? 0;
    const threshold = watchtimeData?.threshold ?? 85;
    useEffect(() => {
        if (mutation.data && !mutation.data.success) {
            toast.error(i18n['course.watchtime.threshold']);
        }
    }, [mutation.data]);
    const handleClick = () => {
        if (!canProgress) {
            toast.error(`${i18n['course.watchtime.threshold']} (${Math.round(percentage)}% / ${threshold}%)`);
            return;
        }
        mutation.mutate({ courseUuid: props.courseUuid, lectureUuid: props.lectureUuid });
    };
    return <>
        <button type="button" className={`inline-flex items-center gap-x-2 rounded-md px-3.5 py-2.5 text-base font-semibold text-white shadow-sm md:bottom-24 md:right-12 ${canProgress ? 'bg-brand-secondary hover:bg-brand-secondary-dark' : 'bg-gray-400 cursor-not-allowed opacity-60'}`} onClick={handleClick} disabled={!canProgress || mutation.isPending || isCheckingWatchtime}>
            {mutation.isPending || isCheckingWatchtime ? (<Spinner />) : (<>
                    {i18n['course.finishLecture']}
                    {!canProgress && ` (${Math.round(percentage)}%)`}
                </>)}
        </button>
    </>;
};
export default CourseLectureProgressButton;
